import {useDispatch, useSelector} from "react-redux";
import {fetchBuilderSettingByKey} from "../../../../../../helpers/MethodHelper";
import React, {Suspense, useEffect} from "react";
import {fetchPropertiesAction} from "../../../../../../redux/actions";

import cloneDeep from 'lodash/cloneDeep';
import Checkers from "../../../../../../helpers/class/Checkers";
import dynamic from "next/dynamic";

const Properties = dynamic( () => import( '../../../../../../components/templates/properties' ), { suspense: true });

interface RelatedPropertiesProps {
    propertyId: number
    app_data: any
    app: any
    builder: any
    slidesPerViewDesktop?: number
    isHotel: boolean
    isChain : boolean
}

export const RelatedProperties = ({propertyId, app, app_data, builder, slidesPerViewDesktop = 2.5, isHotel = false, isChain = false} : RelatedPropertiesProps) => {

    const dispatch = useDispatch()

    const propertiesParams = useSelector(state => state['propertiesParams']);

    const relatedPropertiesViewType = useSelector(
        state => fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_singleproperty_related_properties_view_type')
    );

    const relatedPropertiesLimit = useSelector(
        state => fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_singleproperty_related_properties_limit')
    );

    const sectionTitle = useSelector(
        state => fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_singleproperty_related_properties_title')
    );

    const sectionSubtitle = useSelector(
        state => fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_singleproperty_related_properties_subtitle')
    );

    const propertiesData = useSelector(state => state['propertiesData']);

    const isMobile = useSelector(state => state['appSettings']['isMobile'])

    const isTablet = useSelector(state => state['appSettings']['isTablet'])

    const propertiesFetchHandler = () => {
        let params = cloneDeep(propertiesParams)
        params.limit = relatedPropertiesLimit
        params.mode = 'related'

        dispatch<any>(fetchPropertiesAction(params))
    }

    const relatedPropertiesHandler = () => {
        const itemsToShow = []

        if (propertiesData.properties!=undefined) {
            for (let i = 0; i < propertiesData.properties.length; i++) {
                const propertyItem = propertiesData.properties[i]

                const itemToShow = {
                    id: propertyItem.property_id,
                    title: propertyItem.property_title,
                    image: propertyItem.featured_images[0],
                    loggiaUrl: propertyItem.sourcePath,
                    urlSlug: propertyItem.sourcePath,
                    redirect_url: propertyItem.sourcePath
                }

                itemsToShow.push(itemToShow)
            }
        }

        return itemsToShow
    }

    const itemsToShow = relatedPropertiesHandler()

    useEffect( () => {
        propertiesFetchHandler()
    }, [])

    // {
    //     "id": 2015,
    //     "show_in_different_page": true,
    //     "redirect_url": null,
    //     "title": "Curated Itineraries",
    //     "subtitle": "Personalised Itineraries & Luxury Travel Experiences in Greece",
    //     "urlSlug": "curated_Itineraries",
    //     "loggiaUrl": "/curated_Itineraries",
    //     "has_description": "1",
    //     "body": "<p class=\"MsoNormal\" style=\"margin: 0cm; font-size: medium; font-family: &quot;Times New Roman&quot;, serif; letter-spacing: normal; line-height: 19.200000762939453px;\"><span lang=\"EN-GB\" style=\"font-family: Arial, sans-serif;\"><span style=\"font-size: 14px;\">We are far more than a Villa agency; we are a travel design agency that develops handcrafted itineraries and luxury travel experiences in Greece.</span><o:p></o:p></span></p><p class=\"MsoNormal\" style=\"margin: 0cm; font-size: medium; font-family: &quot;Times New Roman&quot;, serif; letter-spacing: normal; line-height: 19.200000762939453px;\"><span lang=\"EN-GB\" style=\"font-family: Arial, sans-serif;\"><span style=\"font-size: 14px;\">We believe that travel is inherently a life-altering experience, so we provide the</span><o:p></o:p></span></p><p class=\"MsoNormal\" style=\"margin: 0cm; font-family: &quot;Times New Roman&quot;, serif; letter-spacing: normal; line-height: 19.2px;\"><span lang=\"EN-GB\" style=\"font-family: Arial, sans-serif;\"><span style=\"font-size: 14px;\">opportunities to our guests to explore Greece in an authentic and meaningful way,</span><font size=\"3\">&nbsp;</font></span><span style=\"font-size: 14px; font-family: Arial, sans-serif;\">discovering the destination through the eyes of a local expert.</span></p><p class=\"MsoNormal\" style=\"margin: 0cm; font-size: medium; font-family: &quot;Times New Roman&quot;, serif; letter-spacing: normal; line-height: 19.200000762939453px;\"><span lang=\"EN-GB\" style=\"font-family: Arial, sans-serif;\"><span style=\"font-size: 14px;\"><br></span></span></p><p class=\"MsoNormal\" style=\"margin: 0cm; font-size: medium; font-family: &quot;Times New Roman&quot;, serif; letter-spacing: normal; line-height: 19.200000762939453px;\"><span lang=\"EN-GB\" style=\"font-family: Arial, sans-serif;\"><span style=\"font-size: 14px;\">Fascinating culture, unique ancient sites, diverse picture-perfect landscapes, olive groves, wine routes and a culinary heritage rich in flavours and aromas. We invite you to explore Greece in an authentic and meaningful way, discovering the destination through the eyes of a local expert. Enjoy Greece’s captivating history and scenery with custom made private tours, activities and experiences.</span><o:p></o:p></span></p><p class=\"MsoNormal\" style=\"margin: 0cm; font-size: medium; font-family: &quot;Times New Roman&quot;, serif; letter-spacing: normal; line-height: 19.200000762939453px;\"><span lang=\"EN-GB\" style=\"font-family: Arial, sans-serif; font-size: 14px;\">&nbsp;</span></p><p class=\"MsoNormal\" style=\"margin: 0cm; font-size: medium; font-family: &quot;Times New Roman&quot;, serif; letter-spacing: normal; line-height: 19.200000762939453px;\"><span lang=\"EN-GB\" style=\"font-family: Arial, sans-serif;\"><span style=\"font-size: 14px;\">Throughout the travel design process, we always focus on putting relationships</span><o:p></o:p></span></p><p class=\"MsoNormal\" style=\"margin: 0cm; font-family: &quot;Times New Roman&quot;, serif; letter-spacing: normal; line-height: 19.2px;\"><span lang=\"EN-GB\" style=\"font-family: Arial, sans-serif;\"><span style=\"font-size: 14px;\">first. Our collaborative, high-touch approach allows us to work hand-in-hand with</span><font size=\"3\">&nbsp;</font></span><span style=\"font-size: 14px; font-family: Arial, sans-serif;\">our clients, personalise their itinerary, design a flawless trip plan and craft meaningful travel experiences based on their lifestyle. This is what we strive for at All Greek Villas; to create the most memorable, most authentic, and most luxurious travel experience possible for you!</span></p>",
    //     "metaTitle": "We create the most luxurious travel experience in Greece",
    //     "metaDesc": "All Greek Villas is a travel design agency that develops handcrafted itineraries and luxury travel experiences all over Greece.",
    //     "metaKeywords": "greek luxurious travel, luxurious travel in greece, greek luxury travel, luxury travel services, luxury concierge services, concierge in Greece, best travel Greece, vip villas, top greek villas, travel experiences in Greece",
    //     "image": "https://cdn.loggia.gr/lodgeContent/61fd913c1ffd09dc183d973da2c7c95a_thumb.jpg",
    //     "description": ""
    // }

    // useEffect( () => {
    //     dispatch<any>(fetchPropertiesAction(propertiesParams, null))
    // }, [propertiesParams])

    // useEffect( () => {
    //
    //     // dispatch<any>(fetchPropertiesAction(propertiesParams, null))
    //
    //     console.log("relatedProperties", relatedPropertiesViewType, relatedPropertiesLimit, propertyId)
    //
    //     console.log("relatedProperties", propertiesParams)
    //
    //     console.log("relatedProperties", 'relatedPropertiesLimit', relatedPropertiesLimit)
    // })

    const useSwiperHandler = () => {
        if (isMobile || isTablet) {
            if (isMobile) {
                return itemsToShow.length > 1
            } else if (isTablet) {
                return itemsToShow.length > 2
            } else {
                return itemsToShow.length > 3
            }
        } else {
            return true
        }
    }

    const useSwiper = useSwiperHandler()

    return (
        <>
            {
                itemsToShow!=undefined && Checkers.isValidArray(itemsToShow) ?
                    <>
                        <section className="p-b-100 properties-related">
                            <div className={'container p-0'}>
                                <div className=" pb-4 ">
                                    <div className="undefined p-l-0 p-r-0 bg-master-lightest">
                                        <div
                                            className="row justify-content-center w-100 m-0 justify-content-left text-left d-block ">
                                            <div
                                                className="col-12 col-sm-10 text-center d-flex flex-column justify-content-left text-left d-block ">
                                                <p className="block-title m-t-40 hint-text no-margin justify-content-left text-left d-block ">{sectionSubtitle}</p>
                                                <h2
                                                    className=" mt-1 fw-normal m-b-0 justify-content-left text-left d-block ">{sectionTitle}</h2>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <Suspense>
                                    <Properties
                                        key={'properties-swipper-wraper'}
                                        app={app}
                                        app_data={app_data}
                                        builder={builder}
                                        propertiesParams={propertiesParams}
                                        properties_count={null}
                                        designMode={app.designMode}
                                        searchbarRadius={app.searchbarRadius}
                                        searchbarShadow={app.searchbarShadow}
                                        bookingSearchbarWithBedrooms={app.bookingSearchbarWithBedrooms}
                                        googleMapShow={false}
                                        googleMapApiKey={app.googleMapsApiKey}
                                        propertiesFilters={null}
                                        destinationId={null}
                                        showBookingBar={false}
                                        showFiltersBar={false}
                                        thumbClassInherited={useSwiper ? 'col-12 col-sm-12 col-md-12 mb-3 p-l-0 p-r-0' : 'col-12 col-sm-6 col-md-4 mb-3 p-l-0 p-r-0'}
                                        jumbotronTextAlign={'text-left'}
                                        propertiesContainerExtraClass={''}
                                        showTotalPropertiesCount={false}
                                        useSwipper={useSwiper}
                                        slidesPerViewDesktop={slidesPerViewDesktop}
                                        isRelatedSection={true}
                                        isHotel={isHotel}
                                        isChain={isChain}
                                    />
                                </Suspense>
                            </div>
                        </section>
                    </>
                    :
                    <></>
            }
        </>
    )
}